<template>
	<section class="content">
		<div class="blog" v-if="blog">
			<h2 class="blog__title" v-html="blog.title.rendered"></h2>
			<p class="blog__date">{{ blog.date | moment('Do MMMM YYYY') }}</p>
			<p class="blog__content" v-html="blog.content.rendered"></p>
		</div>
	</section>
</template>

<script>
export default {
	name: 'BlogPost',
	data() {
		return { blog: null };
	},
	created() {
		this.$store.dispatch('getBlog', this.$route.params.blogID).then(() => {
			this.blog = this.$store.state.currentBlog;
		});
	},
};
</script>

<style lang="scss" scoped>
.blog {
	&__title {
		margin-bottom: 0;
		text-align: left;
	}

	&__date {
		color: #aaa;
		margin-top: 0;
	}
}
</style>
